import { memo } from 'react';
import { Scale, Check } from 'lucide-react';
import { useCompare } from '../contexts/CompareContext';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../config/translations';

const CompareButton = memo(function CompareButton({ productId }) {
  const { isInCompare, toggleCompare, isFull } = useCompare();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const isSelected = isInCompare(productId);
  const isDisabled = !isSelected && isFull;

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!isDisabled) {
          toggleCompare(productId);
        }
      }}
      disabled={isDisabled}
      className={`absolute top-3 left-3 z-10 p-2 rounded-full shadow-lg transition-all duration-200 min-w-[36px] min-h-[36px] flex items-center justify-center ${
        isSelected
          ? 'bg-primary-600 text-white hover:bg-primary-700'
          : isDisabled
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
          : 'bg-white/90 backdrop-blur-sm text-gray-700 hover:bg-white opacity-0 group-hover:opacity-100 focus:opacity-100'
      }`}
      title={
        isSelected
          ? t('removeFromCompare')
          : isDisabled
          ? t('compareFull')
          : t('addToCompare')
      }
      aria-label={
        isSelected
          ? t('removeFromCompare')
          : isDisabled
          ? t('compareFull')
          : t('addToCompare')
      }
      aria-pressed={isSelected}
    >
      {isSelected ? (
        <Check className="w-4 h-4" />
      ) : (
        <Scale className="w-4 h-4" />
      )}
    </button>
  );
});

export default CompareButton;
